import React from 'react';
import styles from './Menu.module.css';

const MenuType = ({ type }) => (
  <div className={styles.menuType}>
    {type}
  </div>
);

export default MenuType;